<template>
  <div id="plans-container">
    <div id="plans-main-content">
      <div class="form-beneficios">
      <div id="beneficios-container">
        <div class="card-container" id="card-one">
          <div class="align-card-title">
            <img src="./icon-mapa_cobertura.svg" />
            <h4>Cobertura nacional</h4>
          </div>
          <ul class="lista-beneficios" v-if="!isMobile">
            <li>Possibilidade de receber <b>Vale-pedágio</b> de qualquer contratante</li>
            <li style="font-weight: 600;" v-if="isAdhesionFree === 0">Adesão grátis</li>
            <li>Sem mensalidade</li>
            <li>Sem vínculo com o cartão de crédito</li>
            <li>Receba sua TAG em casa ou retire em um parceiro</li>
          </ul>
          <!-- <p>
            Estamos presentes em <span>100%</span> dos estados com vias
            pedagiadas do Brasil.
          </p> -->
          <!-- <img id="square-absolute" src="./quadradoListrado.svg" /> -->
        </div>
        <div class="card-container">
          <div class="align-card-title">
            <img src="./icon-controle-total.svg" />
            <h4>Controle total</h4>
          </div>
          <!-- <p>
            Controle total da conta corrente, dados online das passagens e
            extrato detalhado das movimentações.
          </p> -->
        </div>
        <div class="card-container" id="last-card">
          <div class="align-card-title">
            <img src="./icon-24hours.svg" />
            <h4>Atendimento 24h</h4>
          </div>
          <ul class="lista-beneficios" v-if="isMobile">
            <li>Possibilidade de receber <b>Vale-pedágio</b> de qualquer contratante</li>
            <li style="font-weight: 600;" v-if="isAdhesionFree === 0">Adesão grátis</li>
            <li>Sem mensalidade</li>
            <li>Sem vínculo com o cartão de crédito</li>
            <li>Receba sua TAG em casa ou retire em um parceiro</li>
          </ul>
          <!-- <p>
            Atendemos 24h por dia, 7 dias por semana, em vários canais. Somos o
            melhor atendimento do segmento.
          </p> -->
          <img id="flag-absolute" src="./triangulo.svg" />
        </div>
      </div>
    </div>
      <div id="plans-title">
        <p class="textPlans">+ para você e sua empresa</p>
        <h3>Planos</h3>
        <h5>
          Temos planos que com certeza um deles é ideal para você, é só
          escolher:
        </h5>
      </div>
      <div id="cards-container">
        <PlanInfoPf />
        <PlanInfo />
      </div>
      <h3 id="vale-pedagio-text">Receba seu Vale-pedágio com tranquilidade.</h3>
      <div id="graph-container">
        <div>
          <h1>+80</h1>
          <h3>Concessionárias</h3>
        </div>
        <div>
          <h1>+410</h1>
          <h3>Praças de pedágio</h3>
        </div>
        <div>
          <h1>+1100</h1>
          <h3>Pistas com pedágio automático</h3>
        </div>
      </div>
      <Footer id="footer-hotsite"></Footer>
    </div>
  </div>
</template>
<script>
// Importe o arquivo Vue do componente filho
import PlanInfo from "./planInfo/planInfo.vue";
import PlanInfoPf from "./planInfo/planInfoPF.vue";
import Footer from "../footer/footer.vue";
import Contracts from "../../../../../services/contracts"

export default {
  components: {
    PlanInfo,
    Footer,
    PlanInfoPf,
  },

  data() {
    return {
      isMobile: undefined,
      isAdhesionFree: undefined
    }
  },
  mounted() {

 Contracts.getRoadcardTax().then(res =>{
  this.isAdhesionFree = res;
 }

)
    // Obtendo a largura e altura da tela do dispositivo
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    if(screenWidth <=600){
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }
  }

};
</script>
<style lang="scss" scoped>
.textInformation {
  font-size: 15px;
}

.plansInformation {
  color: #595959;
  font-size: 24px;
  font-family: Inter;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.31px;
  word-wrap: break-word;
}

.textPlans {
  color: #595959;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 16px;
  letter-spacing: 0.58px;
  word-wrap: break-word;
}
.titlePlans {
  // Planos
  color: #1a1a1a;
  font-size: 42px;
  font-family: Inter;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 1.33px;
  word-wrap: break-word;
}
.form-beneficios{
  display: flex;
  flex-direction: column;
}
#graph-container {
  display: flex;
  width: 70vw;
  justify-content: space-between;
}
#graph-container div h1 {
  color: #5d3b81;
  font-weight: bolder;
  font-size: 7rem;
}
#graph-container div h3 {
  color: #464655;
  font-weight: bold;
}
#plans-title {
  margin-top: 2rem;
  width: 70vw;
}
#vale-pedagio-text {
  text-align: center;
  color: #1a293dd4;
  width: 70vw;
}
#plans-title p {
  color: #595959;
}
#plans-title h3 {
  margin: 0;
  // Planos
  color: #1a1a1a;
  font-size: 42px;
  font-family: Inter;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 1.33px;
  word-wrap: break-word;
}
#plans-title h5 {
  // Temos planos que com certeza um deles é ideal para você, é só escolher:
  color: #595959;
  font-size: 24px;
  font-family: Inter;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.31px;
  word-wrap: break-word;
}
#cards-container {
  display: flex;
  width: 70vw;
  justify-content: space-between;
  margin-top: 5rem;
}
#plans-main-content {
  position: absolute;
  top: -8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.align-card-title{
  display: flex;
  gap: 16px;
}
#plans-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  place-content: center;
  background-color: #feffff;
  position: relative;
}
#card-one {
  position: relative;
}
#square-absolute {
  position: absolute;
  right: -2.5rem;
  bottom: 0;
}
#last-card {
  position: relative;
}
#flag-absolute {
  position: absolute;
  top: 0;
  right: -2rem;
}
.card-container div img {
  width: 3.5rem;
  height: 3.5rem;
}
#beneficios-container {
  background: #ffffff;
  width: 70vw;
  height: fit-content;
  box-shadow: 0px 0px 100px #e8f0fc;
  border-radius: 8px;
  justify-content: space-between;
  padding: 3.5rem;
  display: flex;
  margin-bottom: 32px;
  margin-top: 75px;
}
.lista-beneficios{
    width: 75rem;
    margin-top: 24px;
    margin-left: 3rem;
  }
 li{
    font-size: 24px;
  }

.card-container {
  width: 27%;
}
.card-container p {
  color: #595959;
}
.card-container p span {
  font-weight: bold;
}
.card-container div h4 {
  color: #1a1a1a;
  font-weight: bold;
}

@media (min-width: 1920px) {
  #beneficios-container {
    margin-top: 20px;
  }
}

@media (min-width: 1800px) {
  #beneficios-container {
    margin-top: 20px;
  }
}

@media (max-width: 600px) {
  #graph-container {
    display: none;
  }
  #plans-title {
    width: 80vw;
  }
  #plans-title h5 {
    // Temos planos que com certeza um deles é ideal para você, é só escolher:
    color: #595959;
    font-size: 16px;
    font-family: Inter;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0.31px;
    word-wrap: break-word;
  }

  #vale-pedagio-text {
    width: 100%;
  }
  #plans-main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #card-one {
    margin-top: 0 !important;
  }
  #cards-container:first-child {
    margin-top: 0;
  }
  #cards-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 0;
  }
  .card-container {
    margin-top: 2rem;
    width: fit-content;
  }

  .lista-beneficios{
    width: 75rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 24px;
    margin-left: 3rem;
    word-wrap: break-word;
  }
 li{
    font-size: 12px;
    width: 230px;
  }

  .card-container p {
    color: #595959;
  }
  .card-container p span {
    font-weight: bold;
  }

  .card-container div {
    display: flex;
  }
  .card-container div h4 {
    color: #1a1a1a;
    font-weight: bold;
  }

  .card-container div img {
    margin-right: 1rem;
  }

  #square-absolute,
  #flag-absolute {
    display: none;
  }
  #beneficios-container {
    display: flex;
    width: 80vw;
    padding: 1.5rem;
    margin-top: 43px;
    flex-direction: column;
    margin-bottom: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// plans.vue?14794553